// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"358be7eb","74":"dcdbae02","177":"3ebc6471","262":"b0402c1a","348":"d90bc64f","453":"bd6ba36f","696":"39417625","981":"c05b4240"}[chunkId] + ".chunk.js";
};